<header class="p-5 mb-1 rounded-t-lg">
  <h1 class="text-xl">{{data.title}}</h1>
</header>
<hr />

<section class="flex flex-auto p-5">
  <p>{{data.message}}</p>
</section>

<footer class="flex gap-2 justify-end p-5 mt-3">
  @for (button of data.button_actions; track button) {
    <div>
      @if (button.action() !== 'Cancel') {
        <full-button [text]="button.label" (click)="onButtonClick(button.action)" />
      }
      @if (button.action() === 'Cancel') {
        <outline-button [text]="button.label" (click)="onButtonClick(button.action)" />
      }
    </div>
  }
</footer>
